import { render, staticRenderFns } from "./QuestionRadio.vue?vue&type=template&id=01ac9484&scoped=true&"
import script from "./QuestionRadio.vue?vue&type=script&lang=js&"
export * from "./QuestionRadio.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRadio.vue?vue&type=style&index=0&id=01ac9484&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac9484",
  null
  
)

export default component.exports